import React, { useEffect, useRef, useState } from 'react';

import Icon from '../icon/icon';
import classNames from 'classnames';

export interface SnackBarType {
  message: string;
  setSnackbarTxt: (event: any) => any;
  timeout?: number;
  type?: 'success' | 'error' | 'default';
  className?: string;
  children?: React.ReactNode;
}

export const SnackBar = ({
  message,
  setSnackbarTxt,
  timeout,
  type,
  className,
  children,
}: SnackBarType) => {
  const ref = useRef<HTMLDivElement>(null);
  const [didMount, setDidMount] = useState(false);
  const snackBarStyles = {
    success:
      'border-l-4 border-nebula-400 shadow-full bg-white text-nebula-400',
    error: 'border-l-4 border-quasar-400 text-quasar-400 shadow-full',
    default: 'border-neutral-gray-700 bg-neutral-gray-700',
    transferError: `border-l-4 border-quasar-400 shadow-full bg-quasar-400
      text-white`,
    request: 'border-l-4 border-black bg-black text-white',
  };

  const snackBarType =
    (type && snackBarStyles[type]) || snackBarStyles['default'];

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    if (timeout && didMount) {
      const fadeTimer = setTimeout(() => {
        fade();
      }, 1000 * timeout);

      const resetTextTimer = setTimeout(() => {
        setSnackbarTxt('');
      }, 1000 * timeout + 500);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(resetTextTimer);
      };
    }
  }, [didMount]);

  useEffect(() => {
    if (timeout && didMount && null !== ref.current) {
      ref.current.classList.remove('opacity-0');
      ref.current.classList.add('opacity-1');
    }
  }, [message, children]);

  function fade() {
    if (null !== ref.current) {
      ref.current.classList.remove('opacity-1');
      ref.current.classList.add('opacity-0');
    }
  }

  return (
    <div
      data-cy="snackbar"
      className="fixed left-0 px-4 sm:left-1/2 transform sm:-translate-x-1/2 bottom-4 z-50"
    >
      <div
        className={classNames(
          'transform z-40 opacity-1 relative flex items-center justify-between my-0 mx-auto ease-out duration-500 rounded-md p-4 text-sm text-white',
          snackBarType,
          className,
        )}
        ref={ref}
      >
        {children ? children : <span className="mr-4">{message}</span>}
        <span
          className="cursor-pointer pl-4"
          onClick={() => {
            fade();
            setSnackbarTxt('');
          }}
        >
          <Icon
            iconName="x"
            size={10}
            color={type === 'error' ? 'black' : 'white'}
          />
        </span>
      </div>
    </div>
  );
};
